module.exports = __webpack_public_path__ + "static/media/pet-type-final.28e16236.svg";